import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getActiveTripDataById } from '../../services/TripsService';
import { ActiveTripData } from '../../types/Trips';
import { FeaturesManagement } from '../../../featuresControl';
import useGetTripMerge from './useGetTripMerge';
import { ActiveTripByIdRecord, getActiveTripByIdParams } from './activeTripByIdParams';

function useGetActiveTripById(
  fleetId: string,
  trip?: ActiveTripByIdRecord | null,
): UseQueryResult<ActiveTripData> {
  const hasTrip = !!(trip?._id || trip?.mergedTripId);
  const { data: tripMerge } = useGetTripMerge(fleetId, hasTrip);
  const { tripId, showStandaloneAndMergedTrips } = getActiveTripByIdParams(
    trip,
    !!tripMerge?.clientTripMergeEnabled,
  );

  return useQuery(
    ['active-trip', fleetId, tripId, showStandaloneAndMergedTrips],
    async (): Promise<ActiveTripData> => getActiveTripDataById(
      tripId,
      fleetId,
      showStandaloneAndMergedTrips,
    ),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
      enabled: !!tripId,
    },
  );
}

export default useGetActiveTripById;
